<template>
	<div>健康产品</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>